// extracted by mini-css-extract-plugin
export default {"root":"UserPayment_root__solvq","container":"UserPayment_container__zfr4d"};